"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nearbyPatientsMapper = exports.advanceSearchMapper = void 0;
const models_1 = require("../models");
const utils_1 = require("../utils");
const ChatsMapper_1 = require("./ChatsMapper");
const MapperUtils_1 = require("./MapperUtils");
const getClinicianForPatient = (users, patientId, userDirectory) => {
    // Find clinicians whose patients array contains the patientId, and map to userInfo (without patients array)
    return users
        .filter(user => { var _a; return (_a = user.patients) === null || _a === void 0 ? void 0 : _a.some(p => p.id === patientId); })
        .map(user => userDirectory.getUserInfo(user.id))
        .filter((userInfo) => !!userInfo);
};
const advanceSearchMapper = (advanceSearchResponse, userDirectory) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let limit = utils_1.HHNConstants.PAGINATION_LIMIT, page = 0, total = 0, data = [];
    if (advanceSearchResponse === null || advanceSearchResponse === void 0 ? void 0 : advanceSearchResponse.users) {
        ({ limit, page, total, data } = advanceSearchResponse.users);
    }
    const userData = [];
    const nearbyPatients = (_a = (advanceSearchResponse || [])) === null || _a === void 0 ? void 0 : _a.nearbyPatients.map((nearbyPatient) => {
        var _a;
        return (0, exports.nearbyPatientsMapper)(nearbyPatient, (_a = advanceSearchResponse === null || advanceSearchResponse === void 0 ? void 0 : advanceSearchResponse.users) === null || _a === void 0 ? void 0 : _a.data, userDirectory);
    });
    for (const userDataResponse of data) {
        let closestPatient;
        const patientsNearby = userDataResponse.patients.length;
        const userInfo = userDirectory.getUserInfo(userDataResponse.id);
        for (const patient of userDataResponse.patients) {
            const patientData = nearbyPatients.find(nearbyPatient => nearbyPatient.id === patient.id);
            if (!closestPatient || patientData.distance < (closestPatient === null || closestPatient === void 0 ? void 0 : closestPatient.distance)) {
                closestPatient = patientData;
            }
        }
        userData.push(Object.assign(Object.assign({}, userInfo), { closestPatient,
            patientsNearby }));
    }
    return {
        nearbyPatients,
        users: userData,
        limit,
        total,
        page,
        hasNext: (0, MapperUtils_1.calculateHasNext)(limit, total, page),
    };
});
exports.advanceSearchMapper = advanceSearchMapper;
const nearbyPatientsMapper = (nearbyPatient, users, userDirectory) => {
    var _a;
    return Object.assign({ id: nearbyPatient._id, patientStatus: nearbyPatient.patientStatus, servicesToPatient: (0, ChatsMapper_1.servicesToPatientMapper)(nearbyPatient.servicesToPatient), status: models_1.GROUP_STATUS[nearbyPatient.status], type: models_1.USER_TYPE[nearbyPatient.type], uuid: (_a = nearbyPatient.uuid) !== null && _a !== void 0 ? _a : "", distance: nearbyPatient.distance, location: {
            coordinates: nearbyPatient.location.coordinates,
            type: models_1.LOCATION_TYPE[nearbyPatient.location.type],
        }, meta: nearbyPatient.meta, name: nearbyPatient.name }, (users &&
        userDirectory && {
        clinicians: getClinicianForPatient(users, nearbyPatient._id, userDirectory),
    }));
};
exports.nearbyPatientsMapper = nearbyPatientsMapper;
